import OrbitApiV1 from '.'

class DeliveryAPI {
  static async getDelivery(orderId) {
    return OrbitApiV1.httpGet(`/delivery/${orderId}`)
  }

  static async getGrabDeliveryQuote(orderId) {
    return OrbitApiV1.httpGet(`/delivery/grab/getQuote/${orderId}`)
  }

  static async createGrabDelivery(orderId) {
    return OrbitApiV1.httpPost(`/delivery/grab/createDelivery/${orderId}`)
  }
}

export default DeliveryAPI
